module.exports = function(){};